import {useEffect, useState} from 'react'
import { Link } from "react-router-dom";
import { getApiWithToken } from '../Helper/helper';
import BaseUrl from '../baseurl/BaseUrl';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

const Header = () => {
const Navigate=useNavigate()

  useEffect(() => {
    
    window.scrollTo(0, 0);
  
    getData(); // Assuming getData is a function defined outside useEffect
    // getDatas();
    // statusll("pending")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const [userData,] = useState(localStorage.getItem("token"));
  const [datas, setdatas] = useState()
  const getData = () => {
    // setLoader(true)
    getApiWithToken(`${BaseUrl.baseUrl}home`, "", userData)
      .then(({ data }) => {
        console.log("minhaj", data?.home);
        setdatas(data?.home)

        // setfirst_detail(data.home?.first_detail)
        // setsecond_detail(data.home?.second_detail)
        // setthird_detail(data.home?.third_detail)
        // setfour_detail(data.home?.four_detail)
        // setfifth_detail(data.home?.fifth_detail)
         
        
        // setLoader(false)
      })
      .catch((err) => {
        console.log("err---------", err);
      });
  };




  const tokenparent=localStorage.getItem("tokenparent")

  const removeparent=()=>{
    // window.location.reload()
    localStorage.clear("tokenparent")
    Navigate("/")

  }

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const [show, setshow]= useState(false)

  const drop1  =()=>{
    setshow(!show);





  }
  const [show1, setshow1]= useState(false)

  const  drop2 =()=>{
    setshow1(!show1);





  }
  const [show3, setshow3]= useState(false)

  const  drop3 =()=>{
    setshow3(!show3);



    




  }
  return (
    <>
    <header
      id="section-header"
      className="header moto-section"
      data-widget="section"
      data-container="section"
    >
      <div
        className="moto-widget moto-widget-row row-fixed moto-justify-content_center moto-bg-color1_3 moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-auto"
        data-grid-type="sm"
        data-widget="row"
        data-visible-on="-"
        data-spacing="sasa"
        style={{}}
        data-bg-position="left top"
        data-draggable-disabled=""
      >
        <div className="container-fluid">
          <div className="row" data-container="container">
            <div
              className="moto-widget moto-widget-row__column moto-cell col-sm-8 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
              style={{}}
              data-widget="row.column"
              data-container="container"
              data-spacing="aaaa"
              data-bg-position="left top"
            >
              <div
                className="moto-widget moto-widget-row moto-justify-content_center moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                data-grid-type="sm"
                data-widget="row"
                data-visible-on="-"
                data-spacing="aaaa"
                style={{}}
                data-bg-position="left top"
                data-draggable-disabled=""
              >
                <div className="container-fluid">
                  <div className="row" data-container="container">
                    <div
                      className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                      style={{}}
                      data-widget="row.column"
                      data-container="container"
                      data-spacing="aaaa"
                      data-bg-position="left top"
                    >
                      <div
                        className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                        data-widget="text"
                        data-preset="default"
                        data-spacing="aaaa"
                        data-visible-on="-"
                        data-animation=""
                      >
                        <div className="moto-widget-text-content moto-widget-text-editable">
                          <p className="moto-text_system_2">
                            <span className="fa"></span>&nbsp;&nbsp;{datas?.address}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                      style={{}}
                      data-widget="row.column"
                      data-container="container"
                      data-spacing="aaaa"
                      data-bg-position="left top"
                    >
                      <div
                        className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-auto moto-spacin g-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                        data-widget="text"
                        data-preset="default"
                        data-spacing="aaaa"
                        data-visible-on="-"
                        data-animation=""
                        data-draggable-disabled=""
                      >
                        <div
                          className="moto-widget-text-content moto-widget-text-editable"
                          aria-multiline="true"
                        >
                          <p className="moto-text_system_2">
                            <span className="fa"></span>&nbsp;&nbsp;
                            <a 
                              href="tel:1234567890"
                              data-action="call"
                              className="moto-link"
                            >
                              {datas?.phone}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
            <div
              className="moto-widget moto-widget-row__column moto-cell col-sm-4 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
              style={{}}
              data-widget="row.column"
              data-container="container"
              data-spacing="aaaa"
              data-bg-position="left top"
            >
              <div
                id="wid_1595839680_hbtt21zug"
                data-widget-id="wid_1595839680_hbtt21zug"
                className="moto-widget moto-widget-social-links-extended moto-preset-default moto-align-right moto-align-center_mobile-h moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto  "
                data-widget="social_links_extended"
                data-preset="default"
              >
                <ul className="moto-widget-social-links-extended__list">

                  <li className="moto-widget-social-links-extended__item moto-widget-social-links-extended__item-1">
          
     


                 {tokenparent ? <Button onClick={removeparent} className='text-primary' variant="light">Log Out</Button>
:              <Dropdown>
      <Dropdown.Toggle className='text-primary' variant="light" id="dropdown-basic">
         Login
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item><Link style={{color:"#3498db"}} class="dropdown-item fontlar"  to={"/login"}> Surrogate Login</Link>
</Dropdown.Item>
        <Dropdown.Item>    <Link style={{color:"#3498db"}} class="dropdown-item fontlar"  to={"/parent-login"}>intendant Parent Login</Link>
</Dropdown.Item>
        {/* <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
}
                  {/* <Link to="/login"
                     
                      className="moto-widget-social-links-extended__link"
                      target="_self"
                      style={{width:'100px'}}
                    >
                      <span className="">
                      Login
                      </span>
                    </Link> */}
                    {/* <a
                      href="/"
                      className="moto-widget-social-links-extended__link"
                      target="_self"
                    >
                      <span className="moto-widget-social-links-extended__icon fa">
                        
                      </span>
                    </a> */}
                  </li>
                  <li className="moto-widget-social-links-extended__item moto-widget-social-links-extended__item-1">
                  <a
                  style={{marginTop:"6px"}}
                    href="https://www.facebook.com/people/Possible-Surrogacy-Center/61557409828196/"
                    className="moto-widget-social-links-extended__link"
                    target="blank"
                  >
                    <span className="moto-widget-social-links-extended__icon fa">
                      
                    </span>
                  </a>
                </li>
                 {/* <i class="fa-brands fa-facebook"></i> */}
                </ul>
                <style
                  type="text/css"
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n                                                        "
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="moto-widget moto-widget-container undefined moto-container_header_5f1ec9da5d429"
        data-visible-on=""
        data-widget="container"
        data-container="container"
        data-css-name="moto-container_header_5f1ec9da5d429"
        data-bg-position="left top"
      >
        <div
          className="moto-widget moto-widget-row row-fixed moto-justify-content_center moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-auto"
          data-grid-type="sm"
          data-widget="row"
          data-visible-on="-"
          data-spacing="sasa"
          style={{}}
          data-bg-position="left top"
        >
          <div className="container-fluid">
            <div className="row" data-container="container">
              <div
                className="moto-widget moto-widget-row__column moto-cell col-sm-3 col-lg-2 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                style={{}}
                data-widget="row.column"
                data-container="container"
                data-spacing="aaaa"
                data-bg-position="left top"
              >
                <div
                  data-widget-id="wid_1595840209_7o89ubw42"
                  className="moto-widget moto-widget-image moto-widget_with-deferred-content moto-preset-default moto-align-center_mobile-h moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-auto  "
                  data-widget="image"
                >
                  <Link to="/"
                    
                    data-action="home_page"
                    className="moto-widget-image-link moto-link"
                  >
                    <img
                      src={`https://pscapi.devssh.xyz/${datas?.logo}`}
                    //   src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0  '%3E%3C/svg%3E"
                      className="moto-widget-image-picture moto-widget-deferred-content lazyload"
                      style={{width:'115px'}}
                      // data-id={145}
                      title=""
                      alt="hospital"
                    />
                  </Link>
                </div>
              </div>
              <div
                className="moto-widget moto-widget-row__column moto-cell col-sm-9 col-lg-10 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto"
                style={{}}
                data-widget="row.column"
                data-container="container"
                data-spacing="aaaa"
                data-bg-position="left top"
              >
                <div
                  data-widget-id="wid_1595840247_yzpb4jpes"
                  className="moto-widget moto-widget-menu moto-preset-default moto-align-center moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-auto"
                  data-preset="default"
                  data-widget="menu"
                >
                  <Link to="" className="moto-widget-menu-toggle-btn" onClick={toggleMobileMenu} >
                    <i className=" moto-widget-menu-toggle-btn-icon fa fa-bars" />
                  </Link>
                  <div className="moto-widget moto-widget-menu moto-preset-default moto-align-center moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-auto moto-widget-menu-mobile-open">
        {/* <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          Toggle Menu
        </button> */}
        {isMobileMenuOpen &&  (
         <ul className="moto-widget-menu-list moto-widget-menu-list_horizontal">
         {/* <li className="moto-widget-menu-item">
           <Link to="/"
             // href="about-us/index.html"
             data-action="page"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
           >
           Home
           </Link>
         </li> */}

         <li className="moto-widget-menu-item moto-widget-menu-item-has-submenu">
         <Link to="/become-a-surrogate"
             href="#"
             data-action="url"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-widget-menu-link-submenu moto-link"
           >
              Become a Surrogate
             <span className="fa moto-widget-menu-link-arrow" onClick={drop1} />
             </Link>
             {show &&  (
           <ul className="moto-widget-menu-sublist" >
             {/* <li className="moto-widget-menu-item">
               <Link to="/become-a-surrogate"
                 // href="gallery/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                 Become a Surrogate
               </Link>
             </li> */}
             <li className="moto-widget-menu-item">
               <Link to="/requirements-to-become-a-surrogate"
                 // href="departments/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Requirements
               </Link>
             </li>
             <li className="moto-widget-menu-item">
               <Link to="/steps-to-being-a-surrogate"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Steps to Surrogacy
               </Link>
             </li>
             <li className="moto-widget-menu-item">
               <Link to="/compensation"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Compensation
               </Link>
             </li>
             <li className="moto-widget-menu-item">
               <Link to="/faq"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Surrogate FAQ
               </Link>
             </li>
             <li className="moto-widget-menu-item">
               <Link to="/surrogacy-by-state"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
               Surrogacy Law By State
               </Link>
             </li>
           </ul>
             )}
         </li>
             
         <li className="moto-widget-menu-item">
           <Link to="surrogate-database"
             // href="about-us/index.html"
             data-action="page"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
           >
           Surrogate Database
           </Link>
         </li>
           
         <li className="moto-widget-menu-item moto-widget-menu-item-has-submenu">
         <Link to="/become-a-parent"
             // href="#"
             data-action="url"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-widget-menu-link-submenu moto-link"
           >
              Become a Parent
             <span className="fa moto-widget-menu-link-arrow"  onClick={drop2}/>
             </Link>
             {show1 &&  (
           <ul className="moto-widget-menu-sublist">
             {/* <li className="moto-widget-menu-item">
               <Link to="/become-a-surrogate"
                 // href="gallery/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                 Become a Surrogate
               </Link>
             </li> */}
             {/* <li className="moto-widget-menu-item">
               <Link to="/steps-to-parenthood"
                 // href="departments/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Steps to Parenthood
               </Link>
             </li> */}
             <li className="moto-widget-menu-item">
               <Link to="/our-surrogates"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Our Surrogates
               </Link>
             </li>
             {/* <li className="moto-widget-menu-item">
               <Link to="/agency-fees"
                
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Surrogate Costs
               </Link>
             </li> */}
             {/* <li className="moto-widget-menu-item">
               <Link to="/become-parent-international-form"
                 
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                International Parents
               </Link>
             </li> */}
             {/* <li className="moto-widget-menu-item">
               <Link to="/lgbt-surrogac"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
               LGBTQ+ Parents
               </Link>
             </li> */}
             <li className="moto-widget-menu-item">
               <Link to="/ip-faq"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
               IP FAQ
               </Link>
             </li>
             {/* <li className="moto-widget-menu-item">
               <Link to="/surrogacy-by-state"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
               Surrogacy Law By State
               </Link>
             </li> */}
             <li className="moto-widget-menu-item">
               <Link to="/single-parents"
                 // href="blog/index.html"
                 data-action="blog.index"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
               Single Parents
               </Link>
             </li>
           </ul>
             )}
         </li>
         <li className="moto-widget-menu-item">
           <Link to="/about"
             // href="our-team/index.html"
             data-action="page"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
           >
             About Us
           </Link>
         </li>
         {/* <li className="moto-widget-menu-item">
           <Link to="/apply"
             // href="services/index.html"
             data-action="page"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
           >
             Apply
           </Link>
         </li> */}
         <li className="moto-widget-menu-item moto-widget-menu-item-has-submenu">
         <Link to="/apply"
             // href="#"
             data-action="url"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-widget-menu-link-submenu moto-link"
           >
              Apply
             <span className="fa moto-widget-menu-link-arrow" onClick={drop3}/>
             </Link>
             {show3 &&  (
           <ul className="moto-widget-menu-sublist">
             {/* <li className="moto-widget-menu-item">
               <Link to="/become-a-surrogate"
                 // href="gallery/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                 Become a Surrogate
               </Link>
             </li> */}
             <li className="moto-widget-menu-item">
               <Link to="/become-parent-form"
                 // href="departments/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                intendant Parent Application
               </Link>
             </li>
             <li className="moto-widget-menu-item">
               <Link to="/sign-up"
                 // href="departments/index.html"
                 data-action="page"
                 className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
               >
                Surrogate Application
               </Link>
             </li>
            
           </ul>
)}
         </li>
     
       </ul>
        )}
      </div>
                  
                  <ul className="moto-widget-menu-list moto-widget-menu-list_horizontal">
                    {/* <li className="moto-widget-menu-item">
                      <Link to="/"
                        // href="about-us/index.html"
                        data-action="page"
                        className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
                      >
                      Home
                      </Link>
                    </li> */}
                    <li className="moto-widget-menu-item moto-widget-menu-item-has-submenu" style={{fontSize:'8px'}}>
                    <Link to="/become-a-surrogate"
                        href="#"
                        data-action="url"
                        className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-widget-menu-link-submenu moto-link"
                      >
                         Become a Surrogate
                        <span className="fa moto-widget-menu-link-arrow" />
                        </Link>
                      <ul className="moto-widget-menu-sublist">
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/become-a-surrogate"
                            // href="gallery/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                            Become a Surrogate
                          </Link>
                        </li> */}
                        <li className="moto-widget-menu-item">
                          <Link to="/requirements-to-become-a-surrogate"
                            // href="departments/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Requirements
                          </Link>
                        </li>
                        <li className="moto-widget-menu-item">
                          <Link to="/steps-to-being-a-surrogate"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Steps to Surrogacy
                          </Link>
                        </li>
                        <li className="moto-widget-menu-item">
                          <Link to="/compensation"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Compensation
                          </Link>
                        </li>
                        <li className="moto-widget-menu-item">
                          <Link to="/faq"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Surrogate FAQ
                          </Link>
                        </li>
                        <li className="moto-widget-menu-item">
                          <Link to="/surrogacy-by-state"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                          Surrogacy Law By State
                          </Link>
                        </li>
                      </ul>
                    </li>
                    
                         
                    <li className="moto-widget-menu-item">
                {tokenparent?
           <Link to="/surrogate-database"
             // href="about-us/index.html"
             data-action="page"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
           >
           Surrogate Database
           </Link>: <Link to="/parent-login"
             // href="about-us/index.html"
             data-action="page"
             className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
           >
           Surrogate Database
           </Link>
}
         </li>

                    <li className="moto-widget-menu-item moto-widget-menu-item-has-submenu">
                    <Link to="/become-a-parent"
                        // href="#"
                        data-action="url"
                        className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-widget-menu-link-submenu moto-link"
                      >
                         Become a Parent
                        <span className="fa moto-widget-menu-link-arrow" />
                        </Link>
                      <ul className="moto-widget-menu-sublist">
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/become-a-surrogate"
                            // href="gallery/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                            Become a Surrogate
                          </Link>
                        </li> */}
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/steps-to-parenthood"
                            // href="departments/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Steps to Parenthood
                          </Link>
                        </li> */}
                        <li className="moto-widget-menu-item">
                          <Link to="/our-surrogates"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Our Surrogates
                          </Link>
                        </li>
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/agency-fees"
                           
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Surrogate Costs
                          </Link>
                        </li> */}
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/become-parent-international-form"
                            
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           International Parents
                          </Link>
                        </li> */}
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/lgbt-surrogac"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                          LGBTQ+ Parents
                          </Link>
                        </li> */}
                        <li className="moto-widget-menu-item">
                          <Link to="/ip-faq"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                          IP FAQ
                          </Link>
                        </li>
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/surrogacy-by-state"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                          Surrogacy Law By State
                          </Link>
                        </li> */}
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/single-parents"
                            // href="blog/index.html"
                            data-action="blog.index"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                          Single Parents
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                    <li className="moto-widget-menu-item">
                      <Link to="/about"
                        // href="our-team/index.html"
                        data-action="page"
                        className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
                      >
                        About Us
                      </Link>
                    </li>
                    {/* <li className="moto-widget-menu-item">
                      <Link to="/apply"
                        // href="services/index.html"
                        data-action="page"
                        className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-link"
                      >
                        Apply
                      </Link>
                    </li> */}
                    <li className="moto-widget-menu-item moto-widget-menu-item-has-submenu">
                    <Link to="/apply"
                        // href="#"
                        data-action="url"
                        className="moto-widget-menu-link moto-widget-menu-link-level-1 moto-widget-menu-link-submenu moto-link"
                      >
                         Apply
                        <span className="fa moto-widget-menu-link-arrow" />
                        </Link>
                      <ul className="moto-widget-menu-sublist">
                        {/* <li className="moto-widget-menu-item">
                          <Link to="/become-a-surrogate"
                            // href="gallery/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                            Become a Surrogate
                          </Link>
                        </li> */}
                        <li className="moto-widget-menu-item">
                          <Link to="/become-parent-form"
                            // href="departments/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           intendant Parent Application
                          </Link>
                        </li>
                        <li className="moto-widget-menu-item">
                          <Link to="/sign-up"
                            // href="departments/index.html"
                            data-action="page"
                            className="moto-widget-menu-link moto-widget-menu-link-level-2 moto-link"
                          >
                           Surrogate Application
                          </Link>
                        </li>
                       
                      </ul>
                    </li>



                    
                  
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
      
    </>
  )
}

export default Header
